module.exports = __webpack_public_path__ + "img/formF2.19b997db.svg";